import {
  TableCell,
  tableCellClasses,
} from '@mui/material';
import { styled } from '@mui/material/styles';



export const StyledCellHeader = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      fontWeight:"bold"
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      fontWeight:"bold"
    },
  }));
  